// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SAoZ","controls":"styles_controls__1mE4L","charLimit":"styles_charLimit__3987k","input":"styles_input__1qEmx","send":"styles_send__36tH1"};